import PropTypes from "prop-types";

const CourseDropdown = ({ onClose, variant = "desktop" }) => {
  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const courseSections = [
    {
      icon: "https://d31bwppm8yl9g2.cloudfront.net/learner/outskill/grad1.svg",
      title: "Fellowships",
      badge: "6 months | Live",
      description:
        "Deep-dive AI programs to master advanced skills and real projects.",
      courses: [
        {
          name: "AI Generalist Fellowship",
          href: "/6-month-ai-generalist-fellowship",
        },
        { name: "AI Engineering Fellowship", href: "/6-month-ai-engineering" },
      ],
    },
    {
      icon: "https://d31bwppm8yl9g2.cloudfront.net/learner/outskill/grad2.svg",
      title: "Workshops",
      badge: "2-14 days | Live",
      description:
        "Interactive AI sessions for hands-on tool mastery and applications.",
      courses: [
        // { name: "2 Day Gen-AI Mastermind", href: "/2-day-ai-mastermind" },
        // {
        //   name: "2 Day Gen-AI Engineering Mastermind",
        //   href: "/2-day-ai-engineering-mastermind",
        // },
        { name: "3 Day Generative AI Bootcamp", href: "/3-day-generative-ai-bootcamp" },
        { name: "14 Day Gen-AI Bootcamp", href: "/ai-generalist-bootcamp" },
      ],
    },
    {
      icon: "https://d31bwppm8yl9g2.cloudfront.net/learner/outskill/grad3.svg",
      title: "Self-Paced",
      badge: "Hybrid",
      description:
        "Learn AI fundamentals and tools at your own speed, anytime.",
      courses: [
        { name: "AI Accelerator - Live + Recorded", href: "/ai-accelerator" },
        {
          name: "AI Engineering Accelerator - Live + Recorded",
          href: "/engineering-accelerator",
        },
        { name: "AI Tools Mastery", href: "/ai-tools-deepdive" },
      ],
    },
  ];

  if (variant === "mobile") {
    return (
      <div className="space-y-6">
        {courseSections.map((section, index) => (
          <div key={index}>
            <div className="flex items-start gap-3 mb-3">
              <img
                src={section.icon}
                alt={section.title}
                className="w-6 h-6 mt-1"
              />
              <div className="flex-1">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-lg font-medium text-white">
                    {section.title}
                  </h3>
                  <span className="bg-[#B8EF43] px-2 py-1 text-xs font-medium text-black rounded-[2px]">
                    {section.badge}
                  </span>
                </div>
                <p className="text-white/60 text-sm mb-3">
                  {section.description}
                </p>
              </div>
            </div>
            <div className="space-y-2 ml-9">
              {section.courses.map((course, courseIndex) => (
                <a
                  key={courseIndex}
                  href={course.href}
                  className="block text-gray-300 hover:bg-white/5 transition-all duration-200 py-2 px-3 rounded-[2px] text-sm"
                  onClick={handleLinkClick}
                >
                  {course.name}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Desktop variant
  return (
    <div className="pb-6 font-fira-sans">
      <div className="backdrop-blur-[34px] bg-black/30 border border-white/40 rounded-[2px] mt-4">
        <div className="grid md:grid-cols-3 gap-6">
          {courseSections.map((section, index) => (
            <div
              key={index}
              className={
                index === 0
                  ? "border-r border-white/50 p-6"
                  : index < courseSections.length - 1
                    ? "border-r border-white/50 py-6 pr-6"
                    : "py-6 pr-6"
              }
            >
              <div className={index === 0 ? "mb-4" : ""}>
                <div className="mb-3 mt-1">
                  <img src={section.icon} alt={section.title} />
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-2">
                    <h3 className="text-xl font-medium text-white">
                      {section.title}
                    </h3>
                    <span className="bg-[#B8EF43] px-3 py-1 text-xs font-medium text-black rounded-[2px]">
                      {section.badge}
                    </span>
                  </div>
                  <p className="text-white/60 text-sm mb-4 text-left">
                    {section.description}
                  </p>
                </div>
              </div>

              <div className="space-y-2">
                {section.courses.map((course, courseIndex) => (
                  <a
                    key={courseIndex}
                    href={course.href}
                    className="block text-gray-300 hover:bg-white/10 bg-white/5 transition-all duration-200 py-3 px-3 rounded-[2px] text-sm"
                    onClick={handleLinkClick}
                  >
                    {course.name}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

CourseDropdown.propTypes = {
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["desktop", "mobile"]),
};

export default CourseDropdown;
